<template>
  <nav class="podcast-nav">
    <ul class="podcast-nav-list">
      <li
        v-for="section of sections"
        :key="section.slug"
        class="podcast-nav-item"
      >
        <router-link
          :to="{
            name: 'PodcastsSection',
            params: {
              id: podcastId,
              section: section.slug,
              tenant: $route.params.tenant,
            },
          }"
          class="podcast-nav-link"
        >
          {{ section.label }}
        </router-link>
      </li>
      <li class="podcast-nav-filler"></li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    podcastId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sections: [
        {
          slug: 'font',
          label: 'Font',
        },
        {
          slug: 'track',
          label: 'Importa traccia audio',
        },
        {
          slug: 'cover',
          label: 'Copertina',
        },
        {
          slug: 'contents',
          label: 'Contenuti',
        },
        {
          slug: 'seo',
          label: 'SEO',
        },
        {
          slug: 'bookend',
          label: 'Bookend',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.podcast-nav {
  @apply border-t border-solid border-gray-400;

  .podcast-nav-list {
    @apply flex flex-row;

    .podcast-nav-item {
      .podcast-nav-link {
        @include btn-default;
        @apply border-t-0 border-l-0 font-normal text-black text-opacity-50;

        &.router-link-exact-active {
          @apply text-opacity-100 cursor-default;
          border-bottom-color: #fff;

          &:hover {
            @apply bg-transparent;
          }
        }
      }
    }

    .podcast-nav-filler {
      @apply flex-grow border-b border-solid border-gray-400;
    }
  }
}
</style>
